import React from "react";
import { SvgIcon } from "@mui/material";

const MotionCopyIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1033 2.00001L12.9959 3.84001C13.2482 4.08001 13.4165 4.48001 13.4165 4.80001V12C13.4165 12.44 13.0379 12.8 12.5753 12.8H11.7341V13.64C11.7341 14.08 11.3556 14.44 10.893 14.44H3.32257C2.85994 14.44 2.48141 14.08 2.48141 13.64V4.00001C2.48141 3.56001 2.85994 3.20001 3.32257 3.20001H4.16373V2.40001C4.16373 1.96001 4.54225 1.60001 5.00489 1.60001H10.0939C10.4304 1.60001 10.8509 1.76001 11.1033 2.00001ZM12.4912 4.44001L12.4491 4.40001L10.5145 2.56001C10.5145 2.56001 10.5145 2.52001 10.4724 2.52001V4.28001C10.4724 4.36001 10.5565 4.44001 10.6406 4.44001H12.4912ZM10.893 13.64H3.32257V4.00001H4.16373V12.04C4.16373 12.48 4.54225 12.84 5.00489 12.84H10.893V13.64ZM4.96283 12.04H12.5753L12.6174 5.24001H10.6406C10.0939 5.24001 9.63125 4.80001 9.63125 4.28001V2.40001H5.00489L4.96283 12.04Z"
      />
    </SvgIcon>
  );
};

export default MotionCopyIcon;
